/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import MESSANGER from '../BaseComponent/MESSANGER'
import InputMask from 'react-input-mask'
import TMS from '../BaseComponent/TMS'

class CreateTaskType extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      sec: [],
      needProvider: '',
      needProduct: '',
      department: [],
      departmentId: '',
      units: []
    }
  }

  validateMin = (evt) => {
    if ((evt.which != 8 && evt.which != 0 && evt.which < 48) || evt.which > 57) {
      evt.preventDefault()
    }
  }

  componentDidMount() {
    http.get(`${TMS.TMS_MANAGE_BASE_ORGANIZATION_LIST}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          department: response.data.object
        })
      }
    })

    http.get(`${TMS.TMS_MANAGE_BASE_TASKUNIT_LIST}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          units: response.data.object
        })
      }
    })

    // http.get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}`,{
    //
    // }).then(response=>{
    //     if(response.data.error === null){
    //         this.setState({
    //             sec : response.data.object
    //         })
    //     }
    // })
  }

  changeOrg(e) {
    let name = e.target.name
    let value = e.target.value
    if (value === '') {
      this.setState({
        sec: [],
        departmentId: '',
        sectionId: '',
        taskType: ''
      })
    } else {
      this.setState({
        departmentId: value
      })
      http.get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}?departmentId=${value}`, {}).then((response) => {
        if (response.data.error === null) {
          this.setState({
            sec: response.data.object
          })
        } else {
          this.setState({
            sec: []
          })
        }
      })
    }
  }

  addTaskType() {
    let title = document.getElementById('title').value
    let sectionId = document.getElementById('sectionId').value
    let timeMinuteMin = document.getElementById('timeMinuteMin').value
    let timeMinuteMax = document.getElementById('timeMinuteMax').value
    let needProvider = document.getElementById('needProvider').value
    let needProduct = document.getElementById('needProduct').value
    let editableCount = document.getElementById('editableCount').value
    let defaultCount = document.getElementById('defaultCount').value
    let maxActivityCount = document.getElementById('maxActivityCount').value
    let unitId = document.getElementById('unitId').value

    // alert(this.state.needProvider)
    // alert(this.state.needProduct)
    // let needProd = needProduct === 1 ? true : false;
    // let needProv = needProvider === 1 ? true : false;

    var formError = false

    if (
      maxActivityCount === '' ||
      defaultCount === '' ||
      editableCount === '' ||
      unitId === '' ||
      needProvider === '' ||
      needProduct === '' ||
      title === '' ||
      sectionId === '' ||
      timeMinuteMax === '' ||
      timeMinuteMin === ''
    ) {
      formError = true
      message.error('همه فیلد ها وارد شود')
    } else if (needProvider == 0 && needProduct == 1) {
      formError = true
      message.error('نیاز به انتخاب تامین کننده اجباری است')
    } else if (Number(timeMinuteMin) > Number(timeMinuteMax)) {
      formError = true
      message.error('زمان ابتدا نباید بیشتر از زمان انتها باشد')
    }

    if (!formError) {
      let data = {
        title,
        sectionId,
        timeMinuteMin,
        timeMinuteMax,
        needProduct,
        needProvider,
        unitId,
        defaultCount,
        editableCount,
        maxActivityCount
      }

      http
        .post(`${TMS.TMS_MANAGE_BASE_TASK_CREATE}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('نوع فعالیت جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/base/report/tms/taskType')
            }, 2000)
          } else {
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    }
  }

  changeProduct(e) {
    let value = e.target.value
    if (value == 1) {
      this.setState({
        needProvider: 1
      })
    }
  }

  changeProvider(e) {
    let name = e.target.name
    let value = e.target.value
    this.setState({
      [name]: value
    })
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت وظایف</li>
            <li>
              <Link to={'/base/report/tms/taskType'}>نوع وظایف</Link>
            </li>
            <li>افزودن نوع فعالیت</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>افزودن نوع فعالیت</p>
            </div>
            <div className="formComponent">
              <label htmlFor="ماهیت">
                دپارتمان<span className="requireFiled">*</span>
              </label>
              <select
                className="form-control"
                onChange={this.changeOrg.bind(this)}
                name="departmentId"
                id="departmentId"
              >
                <option value="">------</option>
                {this.state.department.map((item, index) => (
                  <option value={item.id} key={index}>
                    {item.title}
                  </option>
                ))}
              </select>

              <label>
                بخش <span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="sectionId">
                <option value="">------</option>
                {this.state.sec.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.title}
                  </option>
                ))}
              </select>

              <label>
                عنوان <span className="requireFiled">*</span>
              </label>
              <input type="text" id="title" className="form-control" />

              <label>
                زمان انجام از (دقیقه) <span className="requireFiled">*</span>
              </label>
              <input
                type="number"
                min={1}
                onKeyPress={this.validateMin.bind(this)}
                id="timeMinuteMin"
                className="form-control"
              />

              <label>
                زمان انجام تا (دقیقه) <span className="requireFiled">*</span>
              </label>
              <input
                type="number"
                min={1}
                onKeyPress={this.validateMin.bind(this)}
                id="timeMinuteMax"
                className="form-control"
              />

              <label>
                نیاز به انتخاب تامین کننده<span className="requireFiled">*</span>
              </label>
              <select
                className="form-control"
                id="needProvider"
                onChange={this.changeProvider.bind(this)}
                name="needProvider"
              >
                <option value="" selected={this.state.needProvider === ''}>
                  ------
                </option>
                <option value={0} selected={this.state.needProvider === 0}>
                  اختیاری
                </option>
                <option value={1} selected={this.state.needProvider === 1}>
                  اجباری
                </option>
                <option value={-1} selected={this.state.needProvider === -1}>
                  عدم انتخاب
                </option>
                {/*<option value={1}>بله</option>*/}
              </select>

              <label>
                نیاز به انتخاب محصول <span className="requireFiled">*</span>
              </label>
              <select
                className="form-control"
                ref={(node) => (this.needProduct = node)}
                onChange={this.changeProduct.bind(this)}
                id="needProduct"
              >
                <option value="">------</option>
                <option value={0}>اختیاری</option>
                <option value={1}>اجباری</option>
                <option value={-1}>عدم انتخاب</option>
              </select>

              <label>
                مقدار پیش فرض تعداد<span className="requireFiled">*</span>
              </label>
              <input type="number" className="form-control" id="defaultCount" />

              <label>
                حداکثر فعالیت تکراری قابل ثبت<span className="requireFiled">*</span>
              </label>
              <input type="number" className="form-control" id="maxActivityCount" />

              <label>
                قابلیت ویرایش تعداد<span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="editableCount">
                <option value="">------</option>
                <option value={0}>خیر</option>
                <option value={1}>بله</option>
              </select>

              <label>
                واحد<span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="unitId">
                <option value="">------</option>
                {this.state.units.map((item, index) => (
                  <option value={item.id} key={index}>
                    {item.title}
                  </option>
                ))}
              </select>

              <button className="btn btn-info btn-block" onClick={this.addTaskType.bind(this)}>
                ثبت بخش
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default CreateTaskType
